var map = {
	"./a.svg": "094b",
	"./all-right.svg": "a70b",
	"./answer.svg": "6d82",
	"./app_logo(2).svg": "0c62",
	"./app_logo.svg": "7b5b",
	"./arrow.svg": "037d",
	"./course.svg": "e4ab",
	"./course_selected.svg": "1a38",
	"./download.svg": "8a71",
	"./goIn.svg": "7b9b",
	"./home.svg": "f17e",
	"./home_selected.svg": "45a4",
	"./i.svg": "59cb",
	"./join_meeting.svg": "a6ca",
	"./join_meeting_selected.svg": "dd31",
	"./link-icon.svg": "b3e0",
	"./mine.svg": "ebd8",
	"./mine_selected.svg": "202b",
	"./open.svg": "82d1",
	"./open_selected.svg": "16ce",
	"./play.svg": "82b2",
	"./poster-icon.svg": "539c",
	"./refresh.svg": "4d03",
	"./specimen.svg": "8d3b",
	"./subject_select.svg": "c153",
	"./subject_select_text.svg": "d954",
	"./subscribe.svg": "8217",
	"./yp_logo.svg": "932e",
	"./zoom_logo.svg": "0d22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a61";